export { PermissionDenied, type PermissionDeniedProps } from './permission-denied';
